/** Panel ichidagi holatlar: yuklanmoqda → xato → bo'sh → kontent. */
import type { ReactNode } from "react";

import { useI18n } from "@/shared/i18n";
import { Icon } from "@/shared/ui/Icon";

export function AsyncBlock({
  loading,
  error,
  empty,
  emptyHint,
  onRetry,
  rows = 3,
  children,
}: {
  loading: boolean;
  error: string;
  empty?: boolean;
  /** Bo'sh holat uchun aniqroq izoh (masalan «filtrga mos yozuv yo'q»). */
  emptyHint?: string;
  onRetry?: () => void;
  rows?: number;
  children: ReactNode;
}) {
  const { t } = useI18n();

  if (loading) {
    return (
      <div className="panel-state" aria-busy="true">
        {Array.from({ length: rows }, (_, index) => (
          <span className="skeleton" key={index} />
        ))}
        <span className="visually-hidden">{t("state.loading")}</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="panel-state is-error" role="status">
        <Icon name="alert" size={18} />
        <p>{error}</p>
        {onRetry ? (
          <button type="button" className="btn btn-outline btn-sm" onClick={onRetry}>
            <Icon name="refresh" size={14} />
            {t("action.retry")}
          </button>
        ) : null}
      </div>
    );
  }

  if (empty) {
    return (
      <div className="panel-state" role="status">
        <Icon name="info" size={18} />
        <p>
          <b>{t("state.empty")}</b>
          <span>{emptyHint ?? t("state.emptyHint")}</span>
        </p>
      </div>
    );
  }

  return <>{children}</>;
}
